import { Divider, HelpCircleFillIcon, Label, Radio, Text, Tooltip } from '@thefarmersfront/kitchen';

import packingGroupedImage from '~/assets/images/delivery-agency/packing-grouped.png';
import packingIndividualImage from '~/assets/images/delivery-agency/packing-individual.png';

import { InfoText } from '~/components/common';

import { DELIVERY_AGENCY_TOOLTIP_MESSAGE } from '~/constants';

import type { TypePostOrdersUploadParams } from '~/types/delivery-agency.types';

import styles from './DeliveryAgencyOrderExcelUploadModal.module.scss';

type OutboundGroupType = TypePostOrdersUploadParams['outboundGroupType'];

const PACKING_TYPE_OPTIONS: { value: OutboundGroupType; label: string; description: string; image: string }[] = [
  {
    value: 'BY_RECEIVER',
    label: '합포장으로 등록',
    description: '배송예정일과 배송지가 같은 주문을\n하나로 포장해요.',
    image: packingGroupedImage,
  },
  {
    value: 'NO_GROUPING',
    label: '개별 포장으로 등록',
    description: '배송예정일과 배송지가 같아도 주문 단위로 따로 포장해요.',
    image: packingIndividualImage,
  },
];

const PackingTypeSelect = ({
  value,
  onChange,
}: {
  value?: OutboundGroupType;
  onChange: (value: OutboundGroupType) => void;
}) => {
  return (
    <>
      <Divider color="gray100" />
      <div className={styles['packing-type']}>
        <div className={styles['label']}>
          <Label required title="포장 방식 설정" />
          <Tooltip
            description={DELIVERY_AGENCY_TOOLTIP_MESSAGE.OUTBOUND_UNIT_CONDITION}
            placement="bottom-left"
            maxWidth="484px"
            portalTarget={document.body}
          >
            <HelpCircleFillIcon size={16} color="gray400" />
          </Tooltip>
        </div>
        <InfoText>배송예정일과 배송지가 같은 주문은 하나로 묶어서 포장할 수 있어요.</InfoText>
        <div className={styles['cards']} role="radiogroup">
          {PACKING_TYPE_OPTIONS.map((option) => (
            <div key={option.value} className={styles['card']} onClick={() => onChange(option.value)}>
              <div className={styles['card-header']}>
                <Radio
                  className={styles['card-radio']}
                  name="outbound-group-type"
                  size="large"
                  label={option.label}
                  labelPlacement="bottom"
                  checked={value === option.value}
                  onChange={() => onChange(option.value)}
                />
                <img className={styles['card-image']} src={option.image} alt="" />
              </div>
              <Text className={styles['card-description']} size="small">
                {option.description}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default PackingTypeSelect;
